import React from 'react';
import { Header, Grid, Input } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';

class Salesorderdetails extends React.Component {

  state = {
    data: [],
    stocks: null
  }

  componentDidMount() {
    this.getwaitingstockdetails();
  }

  componentDidUpdate(props) {
    if (props.partno != this.props.partno || props.brandId != this.props.brandId) {
      this.getwaitingstockdetails();
    }
  }

  getwaitingstockdetails() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Mrp!!!'
    });
    let data1 = { 'partno': this.props.partno, 'brand': this.props.brandId };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchasedetail/getsalesdetails.php',
      success: function(data)
      {
        let stocks;
        context.setState({ load: false });
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            stocks = data[i].stocks;
          }
          context.setState({
            data: data,
            stocks: stocks
          })
        } catch (e) {
          console.log(e);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  render() {
    const { data, stocks } = this.state;
    return (
      <div>
      { stocks ?
        (
          <div style={{color: 'red'}}><b>* There are {stocks} stock(s) waiting in user order!!!</b></div>
        ) :
        (
          <div>There is no stocks are waiting in user order!!!</div>
        )
      }
      </div>
    );
  }
}

export default Salesorderdetails;
